/**
 * Predictive search — progressive enhancement over the header's plain
 * /search link. Opens an inline panel, queries Shopify's suggest API,
 * renders product titles as links (no prices — money stays
 * server-formatted). Escape or an outside click closes; the no-JS path
 * is the untouched link.
 */
(() => {
  if (window.__bunzSearch) return;
  window.__bunzSearch = true;

  const toggle = document.querySelector('[data-search-toggle]');
  const panel = document.querySelector('[data-search-panel]');
  if (!toggle || !panel) return;

  const input = panel.querySelector('[data-search-input]');
  const list = panel.querySelector('[data-search-results]');
  const emptyMsg = panel.querySelector('[data-search-empty]');
  const allLink = panel.querySelector('[data-search-all]');
  let timer = null;
  let lastQuery = '';

  const open = () => {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    input.focus();
  };
  const close = () => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  };

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    panel.hidden ? open() : close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !panel.hidden) {
      close();
      toggle.focus();
    }
  });

  document.addEventListener('click', (e) => {
    if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) close();
  });

  const render = (products, query) => {
    list.textContent = '';
    for (const p of products) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = p.url;
      a.textContent = p.title;
      li.appendChild(a);
      list.appendChild(li);
    }
    list.hidden = products.length === 0;
    emptyMsg.hidden = products.length > 0;
    allLink.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    allLink.hidden = products.length === 0;
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) {
      list.hidden = true;
      emptyMsg.hidden = true;
      allLink.hidden = true;
      return;
    }
    timer = setTimeout(async () => {
      lastQuery = q;
      try {
        // locale root, so suggestion links stay in the shopper's language
        const root = window.Shopify?.routes?.root || '/';
        const res = await fetch(
          `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`
        );
        if (!res.ok) return;
        const data = await res.json();
        if (q !== lastQuery) return; // a newer query is in flight
        render(data.resources.results.products || [], q);
      } catch {}
    }, 250);
  });
})();
